import { all, call, takeEvery } from "redux-saga/effects";
import * as types from "../actions/actionTypes";
import { getAllWorkflowTasksResponse, getWorkflowTaskByIdResponse } from "../actions";
import { axiosPatch } from "../../utils/common/axios";
import { createEntitySagas, extractPayloadAndCallback, runOptimisticAction, toQuery } from "./sagaHelpers";

export const workflowTaskEntity = createEntitySagas({
  entity: "workflowtask",
  endpoint: "workflow-tasks",
  label: "Task",
  scope: "company",
  computedFields: ["brandName", "assignee"],
  selectSlice: (state) => state.workflowtask,
  listKey: "tasks",
  types: {
    getAll: types.GET_ALL_WORKFLOW_TASKS,
    getById: types.GET_WORKFLOW_TASK_BY_ID,
    create: types.CREATE_WORKFLOW_TASK,
    update: types.UPDATE_WORKFLOW_TASK,
    remove: types.DELETE_WORKFLOW_TASK,
  },
  actions: { getAllResponse: getAllWorkflowTasksResponse, getByIdResponse: getWorkflowTaskByIdResponse },
});

// payload: { id, boardColumn } — drag-and-drop column move, the card jumps immediately.
function* moveSaga(action) {
  const { payload, callback } = extractPayloadAndCallback(action);
  const { id, boardColumn } = payload;
  yield* runOptimisticAction({
    entity: "workflowtask",
    selectList: workflowTaskEntity.selectList,
    id,
    changes: { boardColumn },
    request: () => axiosPatch(`workflow-tasks/${id}/move${toQuery({ boardColumn })}`),
    errorFallback: "Could not move task",
    callback,
  });
}

export function* workflowtaskSaga() {
  yield all([call(workflowTaskEntity.watcher), takeEvery(types.MOVE_WORKFLOW_TASK, moveSaga)]);
}
